<!-- 米测MeLab首页 -->
<template>
  <div class="container">
    <Topbar ref="topBar"></Topbar>
    <!-- 导航 -->
    <!-- style="position: fixed !important;z-index: 100;" -->
    <div class="topBar_header" ref="topBarHeader"
      :style="{ position: topHeaderFixed ? 'fixed' : 'static', left: 0, top: 0, zIndex: 100 }">
      <img class="logo_img" @click="jumpHome" src="https://static.xueyanhui.com/static/defaults/mice_logo_black.png"
        alt="" />
      <div class="menus">
        <div class="menu_item" :class="{
          activeItem: $route.path.includes(item.path) && item.isSameRoute ? item.compsName == activeView : $route.path.includes(item.path),
          show_drawer: item.compsName == 'category',
          menu_item1: index == 0
        }" v-for="(item, index) in menus" :key="index" @click="switchTab(item)" @mouseover="tabMouseover(item)">
          <span class="menu_tag_wrap">
            {{ item.text }}
            <span class="menu_tag" v-show="item.tag">{{ item.tag }}</span>
          </span>
        </div>
      </div>
      <div class="right_box">
        <div class="search">
          <img class="search_icon" src="@/assets/imgs/homeIcon/search.png">
          <!-- <el-input class="search_inp" v-model="searchText" clearable placeholder="请输入仪器名称或型号" /> -->
          <el-autocomplete class="search_inp" v-model="searchText" :popper-append-to-body="false" clearable
            :fetch-suggestions="getSearchList" :placeholder="searchKeywordPar" @select="clickSearchItem"
            value-key="name" value="id" :trigger-on-focus="true"></el-autocomplete>
          <div class="search_btn" @click="toSearchResult">搜索</div>
        </div>
        <div class="yucun" @click="prevSave"><img src="@/assets/imgs/homeIcon/gift.png" alt="" class="img">
          预存有礼
          <div v-if="yucunTag" class="yucun_tag">{{ yucunTag }}</div>
        </div>




        <el-dropdown v-if="userInfo && JSON.stringify(userInfo) != '{}'" placement="bottom" @command="handleCommand">
          <span class="el-dropdown-link" style="cursor: pointer;font-size: 14px;">
            {{ userInfo.nickname || 123 }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- 我的订单、我的收藏、发票管理、优惠券、我的团队、退出登录 -->
            <el-dropdown-item command="myOrder">我的订单</el-dropdown-item>
            <el-dropdown-item command="myInvoice">发票管理</el-dropdown-item>
            <el-dropdown-item command="myCoupon">优惠券</el-dropdown-item>
            <el-dropdown-item command="myTeam">
              <div>{{ myTeam }}</div>

            </el-dropdown-item>
            <el-dropdown-item command="invitationAssistance">邀请好友</el-dropdown-item>

            <el-dropdown-item command="logout">退出登录</el-dropdown-item>

            <!-- <el-dropdown-item command="myCenter">个人中心</el-dropdown-item> -->
            <!-- <el-dropdown-item command="myInvoice">我的发票</el-dropdown-item> -->
            <!-- <el-dropdown-item command="myTeam">我的团队</el-dropdown-item> -->
            <!-- <el-dropdown-item command="memberCenter">会员中心</el-dropdown-item> -->
            <!-- <el-dropdown-item command="logout">我的积分</el-dropdown-item> -->
            <!-- <el-dropdown-item command="logout">退出登录</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <div class="login" v-else><span @click="toLogin">登录</span> | <span @click="toRegister">注册</span> </div>


      </div>
    </div>
    <div ref="centerRef">
      <router-view></router-view>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="content">
        <div class="left">
          <img src="@/assets/imgs/logo2.png" alt="" class="logo2">
          <el-link class="net" @click="jumpToOfficeNet">www.micetech.cn</el-link>
          <div class="tel">156-3737-0993</div>
          <div class="tel_text">MeLab测试服务热线</div>
          <div class="ask">
            <el-popover placement="bottom" width="155" trigger="click" popper-class="wechat_ask">
              <div style="color: #151b48;font-size: 12px;font-weight: bold;margin: 5px 0;text-align: center;">
                <p>微信扫一扫下方二维码</p>
                <p>进行咨询</p>
              </div>
              <el-image
                src="https://static.xueyanhui.com/static/wechatQrc/326829baefad42a8a2290b56f489ee77.png"></el-image>
              <div slot="reference" @click="askNow">立即咨询</div>
            </el-popover>
          </div>

        </div>

        <div class="middle">
          <div class="qun_wrap">
            <div class="title">平台技术交流群</div>
            <div class="qun">
              <div class="item" v-for="(item, index) in qun" :key="index">
                <img class="icon" src="@/assets/imgs/homeIcon/qq.png" />
                <div class="qun_no">
                  {{ item.no }}
                </div>
              </div>
            </div>
          </div>
          <div class="info">
            <div class="info_item" v-for="(item, index) in list3" :key="index">{{ item }}</div>
          </div>
          <div class="info2">
            <div class="info2_item" v-for="(item, index) in list4" :key="index">
              <div v-if="item.label === '技术顾问'">
                <el-popover placement="bottom" width="155" trigger="click" popper-class="wechat_ask">
                  <div style="color: #151b48;font-size: 12px;font-weight: bold;margin: 5px 0;text-align: center;">
                    <p>微信扫一扫下方二维码</p>
                    <p>进行咨询</p>
                  </div>
                  <el-image
                    src="https://static.xueyanhui.com/static/wechatQrc/326829baefad42a8a2290b56f489ee77.png"></el-image>

                  <div slot="reference">
                    {{ item.label }}
                  </div>
                </el-popover>
              </div>
              <div v-else @click="item.function()">
                {{ item.label }}
              </div>
            </div>



          </div>
        </div>

        <div class="right">
          <div class="qr_item" v-for="(item, index) in list5" :key="index">
            <img :src="item.src" alt="" class="qr_img">
            <div class="qr_text">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="record_number">
        <div class="record_text">@2023 米测MeLabAll Rights Reserved 武汉米测科技有限公司 鄂ICP备2023024429号-1</div>
      </div>
    </div>
    <!-- <message-box></message-box> -->
    <complainDialog :visible="showComplainDialog" @closeDialog="closeDialog"></complainDialog>

    <!-- 测试分类抽屉 -->
    <div class="drawer" :class="{ show_drawer: showDrawer }" @mouseover="drawerMouseover" @mouseout="mouseout">
      <div class="content c">
        <div class="list">
          <div class="list_item" v-for="item in drawerData" :key="item.id">
            <div class="left">
              <div class="parent_node">
                <i :class="['iconfont', item.icon && item.icon.replace('#', '')]"></i>
                {{ item.name }}
              </div>
            </div>
            <div class="right">
              <div class="tag_item" v-for="(i, ix) in item.children" :key="ix" @click="toPath(i)">
                {{ i.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边悬浮栏 -->
    <RightBar></RightBar>
    <div class="mask" v-if="showDrawer" @click="showDrawer = false"></div>
    <elementsPeriodicTable v-if="false" :multiple="true" @choiceEle="choiceEle"></elementsPeriodicTable>


  </div>
</template>

<script>
import Topbar from '@/components/Topbar.vue'
// import Footer from '@/components/Footer.vue'
// import MessageBox from '@/components/messageBox.vue'
import RightBar from '@/components/RightBar.vue'
import elementsPeriodicTable from '@/components/elementsPeriodicTable'
// import { localStorage } from "@/tool/storage";
import { mapState, mapActions, mapMutations } from 'vuex'
import { getAllCategory, searchKeyword } from '@/api/goods'
import { getJournalSpeed, getTagList } from '@/api/home'
import ComplainDialog from "@/components/dialogComponents/complainDialog.vue";
import { getSearchKeyword } from "@/api/sys";
import { Timer } from "@/tool/Timer";

export default {
  name: 'HomeView',
  components: {
    ComplainDialog,
    Topbar,
    // Footer,
    RightBar,
    // MessageBox,
    elementsPeriodicTable
  },
  data() {
    return {
      searchText: '',
      showComplainDialog: false,
      activeView: 'homeView',
      showDrawer: false,
      yucunTag: null,
      topHeaderFixed: false,

      menus: [
        {
          text: '首页',
          compsName: 'homeView',
          path: '/home',
          showDrawer: false
        },
        {
          text: '测试分类',
          compsName: 'category',
          path: '/category',
          showDrawer: true
        },
        {
          text: '原位测试',
          compsName: 'situTest',
          path: '/professionalDetail',
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10050' : '10040' },
          showDrawer: false,
          isSameRoute: true
        },
        {
          text: '同步辐射',
          compsName: 'syncRdiation',
          path: '/professionalDetail',
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10048' : '10025' },
          showDrawer: false,
          isSameRoute: true
        },
        {
          text: '球差电镜',
          compsName: 'syncRdiation1',
          path: '/professionalDetail',
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10103' : '10025' },
          showDrawer: false,
          isSameRoute: true
        },
        {
          text: '高端测试',
          compsName: 'acTem',
          path: '/professionalDetail',
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10049' : '10018' },
          showDrawer: false,
          isSameRoute: true
        },
      ],
      list: [
        { title: '加入米测VIP', subTitle: '首样免费测/先测试后付费', src: '' },
        { title: '预先有禮物', subTitle: '预存最高增值10%', src: '' },
        { title: '顶刊速递', subTitle: '期刊资讯抢先看', src: '' },
        { title: '论文致谢', subTitle: '最高奖励2000元', src: '' },
      ],

      goldActive: 0,

      paperList: [],
      searchKeywordList: [],
      qun: [
        { no: '文献求助QQ群：949294810' },
        // { no: '原位表征QQ交流群：949294810' },
        { no: '测试交流QQ群：593209902' },
      ],
      list3: ['平台相关', '网站指南', '协议条款', '服务用户'],
      list4: [
        { 'label': '关于我们', function: () => { this.$router.push('/aboutUs') } }
        , { 'label': '新手指引', function: () => { this.$router.push('/guideView') } }
        , { 'label': '用户协议', function: () => { this.$router.push('/serviceClause?id=10') } }
        , { 'label': '意见反馈', function: () => { this.showComplainDialog = true } }
        , { 'label': '合作伙伴', function: () => { this.$router.push('/cooperate') } }
        , { 'label': '技术顾问', function: () => { } }
        , { 'label': '隐私条款', function: () => { this.$router.push('/serviceClause?id=2') } }
        , { 'label': '发布需求', function: () => { this.$router.push('/releaseDemand') } }
      ],
      list5: [
        { src: require('@/assets/imgs/homeIcon/qr1.jpg'), text: '米测MeLab公众号' },
        { src: require('@/assets/imgs/homeIcon/qr2.jpg'), text: '米测MeLab视频号' },
      ],
      searchCurrentIndex: 0,
      drawerData: [],
      searchTimer: null,
      drawerActive: 1,
    }
  },
  created() {
    this.getTagListFn()
    this.activeView = this.$route.path
    this.getAllCategory()
    this.getJournalSpeed()
    this.getSearchKeywordList()
    this.startTimer()
  },
  computed: {
    ...mapState('user', ['userInfo', 'teamInfo']),
    activeDrawerData() {
      return this.drawerData[this.drawerActive - 1]
    },
    myTeam() {
      return this.teamInfo.id ? '我的团队' : '创建团队'
    },
    searchKeywordPar() {
      if (this.searchKeywordList.length === 0) {
        return '请输入仪器名称或型号'
      }
      // 循环，每三秒取一个
      return this.searchKeywordList[this.searchCurrentIndex]
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },

  methods: {
    ...mapActions('user', ['logout']),
    ...mapMutations('user', ['clearUserInfo']),

    handleScroll() {
      if (this.$refs.topBarHeader && this.$refs.topBarHeader?.getBoundingClientRect()) {
        const top = (this.$refs.topBarHeader?.getBoundingClientRect().top)
        // console.log('BarHeader', top);
        if( top <= 0){
          this.topHeaderFixed = true
        }
      }
      const centerTop = this.$refs.centerRef?.getBoundingClientRect()?.top
      if(centerTop >= 10){
          this.topHeaderFixed = false
      }

    },

    // 立即咨询
    askNow() {
      console.log('userInfo', this.userInfo);
    },
    startTimer() {
      this.searchTimer = new Timer(5000, 24 * 60 * 60 * 1000, () => {
        this.searchCurrentIndex = (this.searchCurrentIndex + 1) % this.searchKeywordList.length;
      }, () => { });
      this.searchTimer.start()
    },

    getSearchKeywordList() {
      getSearchKeyword().then(res => {
        this.searchKeywordList = res
      })

    },

    // 点击下拉列表
    handleCommand(command) {
      if (command == 'myOrder') {
        this.$router.push("/myCenter/myOrders");
      }
      else if (command == 'invitationAssistance') {
        this.$router.push('/myCenter/invitationAssistance')
      }
      else if (command == "myInvoice") {
        this.$router.push("/myCenter/invoiceInfoAdmin");
      }
      else if (command == 'myCoupon') {
        this.$router.push('/myCenter/coupon')
      }
      else if (command == 'myTeam') {
        if (localStorage.getItem('teamInfo')) {
          this.$router.push('/myCenter/myTeam')
        } else {
          this.$router.push('/myCenter/addTeam')
        }
      }

      else if (command == "logout") {
        this.$confirm("确定要退出登录吗？", "提示").then(() => {
          this.logout().then(() => {
            this.$message({ type: "success", message: "退出登录成功" });
            this.clearUserInfo({}); // 更新vuex
            this.resetToken();
            this.$router.push("/Login");
          });
        });
      } else if (command == "myCenter") {
        this.$router.push("/myCenter/centerHome");
      } else if (command == "memberCenter") {
        // 判断是不是会员
        console.log(this.userInfo.role);
        const { role } = this.userInfo;
        if (role && role.includes("BUYER_VIP")) {
          // 是会员 去会员中心页面
          this.$router.push("/memberCenter");
        } else {
          // 不是会员  去了解会员页面
          this.$router.push("/understandMember");
        }
      }
    },

    jumpHome() {
      this.$router.push('/')
      this.clearActiveOfTopbar()
    },

    // 获取期刊速递
    getJournalSpeed() {
      getJournalSpeed({ currentPage: 1, pageSize: 9 }).then(res => {
        this.paperList = res.records || []
        // this.paperList = [...res.records,...res.records,...res.records,res.records]
      })
    },
    closeDialog() {
      this.showComplainDialog = false;
    },
    // 跳转1结果页面
    toSearchResult() {
      if (!this.searchText) {
        if (this.searchKeywordPar === '请输入仪器名称或型号') {
          return;
        }
        this.searchText = this.searchKeywordPar
      }
      if (!this.searchText) {
        return
      }

      let path = `/searchResult?keyword=${this.searchText}`
      this.$router.push(path)
      this.$EventBus.$emit('search', this.searchText)
      this.clearActiveOfTopbar()
    },
    // 预存有礼
    prevSave() {
      this.$router.push('/deposit')
      this.clearActiveOfTopbar()
    },
    // 跳转登录页面
    toLogin() {
      this.$router.push("/Login");
      this.clearActiveOfTopbar()
    },
    // 跳转注册页面
    toRegister() {
      this.$router.push("/Register?type=0");
      this.clearActiveOfTopbar()
    },
    // 跳转官网
    jumpToOfficeNet() {
      window.open("https://www.micetech.cn")
    },
    // 获取搜索列表
    getSearchList(searchStr, callBack) {
      if (!searchStr) {
        callBack([])
      } else {
        searchKeyword({ keyword: searchStr }).then((res) => {
          callBack(res)
        })
      }
    },
    clickSearchItem(item) {
      if (item.id) {
        this.$router.push(`/details/${item.id}`)
      }
    },

    // 测试分类抽屉
    tabMouseover(item) {
      if (!this.$route.path.includes('category')) {
        this.showDrawer = item.showDrawer
      }
    },

    mouseout() {
      this.showDrawer = false
    },

    // 获取分类的数据
    getAllCategory() {
      getAllCategory().then((res) => {
        this.drawerData = res
      })
    },

    // 旗袍获取
    getTagListFn() {
      getTagList().then((res) => {
        if (res.length) {
          res.forEach(item => {
            if (item.module == '预存有礼') {
              this.yucunTag = item.tag
            }

            this.menus.forEach(i => {
              if (item.module == i.text) {
                i.tag = item.tag
              }
            })
          })

        }
      })
    },


    clearActiveOfTopbar() {
      this.$refs.topBar.activeView = ''
    },

    // 切换tba
    switchTab(item) {
      if (item.isSameRoute) {
        this.activeView = item.compsName
      } else {
        this.activeView = item.path
      }
      this.showDrawer = false
      this.$router.push({ path: item.path, query: item.query })
      // 点击这个需要给顶部工具栏的活跃状态置空
      this.clearActiveOfTopbar()
    },
    // 点击抽屉的子项 跳转页面
    toPath(item) {
      if (item.path) {
        if (item.path == '/mall') {
          window.open('https://mall.micetech.cn/#/searchResult')
        } else {
          let path = `${item.path}?id=${item.id}`
          this.$router.push(path)
        }
      } else {
        this.$router.push(`/category?id=${item.id}`)
      }
      // let path;
      // if (isParent) {
      //   path = item.path + `?parentId=${item.id}&childrenId=${item.id}`;
      // } else {
      //   path = item.path + `?parentId=${item.parentId}&childrenId=${item.id}`;
      // }
      // this.$router.push(path);
    },
    // 切换抽屉左侧list
    changeActive(value) {
      // this.parentNode = item;
      this.drawerActive = value
    },
    // 抽屉移入事件
    drawerMouseover() {
      this.showDrawer = true
    },


    // 元素周期表选择事件
    choiceEle(value) {
      console.log(value)
    }
  }
}
</script>

<style lang="less" scoped>
.el-popover.wechat_ask {
  border-radius: 12px;
}
</style>


<style lang="less" scoped>
.container {
  height: 100%;
  background-color: #f8f8f8;


  .topBar_header {
    // overflow: hidden;
    padding-left: 30px;
    box-sizing: border-box;
    width: 100%;
    height: 80px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    //justify-items: center;


    .logo_img {
      width: 147px;
      height: 56px;
      display: flex;
      justify-content: flex-start;
      cursor: pointer;
    }

    .menus {
      //flex: ;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .menu_item {
      width: 140px;
      line-height: 80px;
      cursor: pointer;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: 600;
      font-size: 19px;
      color: #100926;
      text-align: left;
      font-style: normal;
      text-align: center;
      white-space: nowrap;



      &:hover {
        color: @main-color;
      }
    }

    .menu_tag_wrap {
      position: relative;
    }

    .menu_tag {
      position: absolute;
      left: 0;
      top: -25px;
      height: 25px;
      padding: 0 10px;
      line-height: 25px;
      font-size: 12px;
      background-color: #fe9b05;
      text-align: left;
      color: #fff;
      border-radius: 30px 30px 30px 0;
    }


    .menu_item1 {
      width: 100px;
    }

    .right_box {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
    }

    .search {
      width: 368px;
      height: 44px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #6742D6;
      line-height: 44px;
      margin-top: 6px;
      margin-right: 20px;

      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 16px;
      color: #FFFFFF;
      display: flex;
      align-items: center;

      /deep/ .el-input__inner {
        border: 0;
        background-color: rgba(255, 255, 255, 0.3) !important;
      }

      .search_icon {
        width: 18px;
        height: 18px;
        margin-left: 11px;
      }

      .search_inp {
        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
        font-weight: normal;
        font-size: 14px;
        color: #100926;
        line-height: 14px;
        text-align: left;
        font-style: normal;
        flex: 1;
        border: 0;
        color: red;
        background-color: #fff;
        margin-right: 24px;
      }

      .search_btn {
        width: 82px;
        height: 44px;
        background: #6742D6;
        border-radius: 0px 10px 10px 0px;
        cursor: pointer;
      }
    }

    .yucun {
      width: 150px;
      height: 44px;
      margin-right: 20px;
      background: #FF414B;
      border-radius: 10px 10px 10px 10px;
      margin-top: 6px;
      line-height: 44px;
      cursor: pointer;
      font-family: Alibaba PuHuiTi 2.0,
        Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 16px;
      color: #FFFFFF;
      position: relative;

      .img {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-right: 2px;
      }


      .yucun_tag {
        position: absolute;
        right: 0;
        top: -15px;
        height: 25px;
        padding: 0 10px;
        line-height: 25px;
        font-size: 12px;
        background-color: #fe9b05;
        text-align: left;
        color: #fff;
        border-radius: 30px 30px 30px 0;
      }
    }

    .login {
      width: 120px;
      height: 44px;
      background: #6742D6;
      border-radius: 10px 10px 10px 10px;
      margin-top: 6px;
      line-height: 44px;
      cursor: pointer;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 16px;
      color: #FFFFFF;
      margin-right: 24px;
    }

  }



  .ad {
    width: 100%;
    height: 580px;
    //background-image: url(@/assets/imgs/bg.png);
    background-size: 100% 100%;
    // overflow: hidden;
    position: relative;

    .join_mc {
      position: absolute;
      left: 50%;
      bottom: -49px;
      transform: translate(-50%, 0);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10;

      .join_mc_item {
        width: 310px;
        height: 116px;
        background: #fff;
        box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
        border-radius: 12px 12px 12px 12px;
        margin-right: 14px;

        display: flex;
        align-items: center;
      }

      .join_mc_icon {
        width: 72px;
        height: 72px;
        background-color: red;
        margin-left: 14px;
        margin-right: 13px;
      }

      .join_mc_content {
        text-align: left
      }

      .join_mc_title {
        height: 25px;
        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
        font-weight: normal;
        font-size: 18px;
        color: #100926;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        margin-bottom: 8px;
      }

      .join_mc_subtitle {
        height: 20px;
        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
        font-weight: normal;
        font-size: 14px;
        color: #9099b7;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .gold {
    width: 100%;
    min-height: 815px;
    padding-top: 148px;
    background: #F6F1FD;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tabs {
      width: 1280px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px 12px 12px 12px;
      margin-bottom: 16px;

      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 24px;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .tab_item {
        cursor: pointer;
        width: 100%;
        text-align: center;
        height: 64px;
        line-height: 64px;
        text-align: center;
        border-radius: 12px 12px 12px 12px;
        color: #000000;
        margin-right: 16px;
      }

      .tab_item:last-child {
        margin-right: 0;
      }

      .tab_item_active {
        background: #6742D6;
        color: #FFFFFF;
      }
    }

    .content {
      width: 1280px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .content_item {
        width: 632px;
        height: 254px;
        padding: 19px;
        background: #FFFFFF;
        box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
        border-radius: 12px 12px 12px 12px;
        margin-bottom: 16px;
        display: flex;
        border: 1px solid transparent;

        .img {
          width: 289px;
          height: 216px;
          border-radius: 12px 12px 12px 12px;
          background-color: red;
          margin-right: 18px;
        }

        .right {
          text-align: left;

          .title {
            height: 39px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 28px;
            color: #100926;
            line-height: 33px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 4px;
          }

          .status {
            display: flex;
            height: 17px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 12px;
            font-style: normal;
            text-align: center;
            line-height: 17px;
            margin-bottom: 11px;
          }

          .status_item {
            min-width: 52px;
            height: 22px;
            background: rgba(132, 94, 246, .3);
            border-radius: 6px 6px 6px 6px;
            margin-right: 8px;
          }

          .type,
          .type_eng {
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: 600;
            font-size: 14px;
            color: #100926;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .type_eng {
            margin-bottom: 16px;
          }

          .desc {
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 12px;
            color: #8f99b7;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
      }

      .content_item:hover {
        border: 1px solid #845EF6;
      }
    }

    .content_item:last-child {
      margin-right: 0;
    }

    .content1 {
      width: 1280px;
      margin-bottom: 120px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .content1_item {
        width: 308px;
        height: 368px;
        background: #FFFFFF;
        box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
        border-radius: 12px 12px 12px 12px;
        margin-bottom: 12px;
        border: 1px solid transparent;
        // border: 1px solid #845EF6;
      }

      .img {
        width: 306px;
        height: 259px;
        border-radius: 11px 11px 0px 0px;
        margin-bottom: 21px;
      }

      .title {
        height: 34px;
        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
        font-weight: normal;
        font-size: 24px;
        color: #100926;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 6px;
        margin-left: 16px;
      }

      .subtitle {
        height: 20px;
        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
        font-weight: normal;
        font-size: 14px;
        color: #8892b0;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 16px;
      }

      .content1_item:hover {
        border: 1px solid #845EF6;

        .title,
        .subtitle {
          color: #845EF6;
        }

      }
    }
  }

  .test {
    width: 100%;
    height: 1109px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;
    padding-top: 38px;

    .title {
      height: 45px;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 32px;
      color: #100926;
      line-height: 38px;
      font-style: normal;
      text-transform: none;
      margin-bottom: 16px;
    }

    .desc1 {
      width: 1280px;
      height: 48px;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 14px;
      color: #100926;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 32px;
    }

    .img {
      width: 1280px;
      height: 435px;
      border-radius: 12px 12px 12px 12px;
      background-color: red;
      margin-bottom: 32px;
    }

    .desc2 {
      width: 1280px;
      height: 48px;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 14px;
      color: #100926;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 56px;
    }

    .imgs {
      width: 1280px;
      height: 208px;
      display: flex;
      align-items: center;
      margin-bottom: 48px;

      .item {
        width: 404px;
        height: 208px;
        // background: linear-gradient( 180deg, rgba(16,9,38,0) 29%, #100926 100%);
        border-radius: 12px 12px 12px 12px;
        position: relative;
        margin-right: 34px;
        padding-left: 24px;
        padding-top: 105px;

        .item_img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background-color: red;
          border-radius: 12px 12px 12px 12px;
          z-index: 0;
        }

        .title {
          height: 34px;
          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 8px;
        }

        .subtitle {
          height: 40px;
          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          position: relative;
          z-index: 2;
        }
      }

      .item:last-child {
        margin-right: 0;
      }

    }

    .test_btn {
      width: 202px;
      height: 54px;
      background: #6742D6;
      border-radius: 12px 12px 12px 12px;
      text-align: center;
      line-height: 54px;

      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 18px;
      color: #FFFFFF;
      font-style: normal;
      text-transform: none;
    }
  }

  .speech {
    width: 100%;
    height: 601px;
    background-color: #F6F1FD;
    padding: 51px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      height: 45px;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 32px;
      color: #100926;
      font-style: normal;
      text-transform: none;
      margin-bottom: 24px;
    }

    .speech_content {
      display: flex;
      justify-content: center;
      align-items: center;

      .item {
        width: 306px;
        height: 418px;
        padding: 0 11px;

        background: #FFFFFF;
        box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #845FF6;
        margin-right: 19px;

        .video {
          width: 306px;
          height: 195px;
          border-radius: 12px 12px 0px 0px;
          margin-bottom: 24px;
        }

        .people {
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .avator {
            width: 68px;
            height: 68px;
            border-radius: 50%;
            margin-right: 16px;
          }

          .name {
            height: 31px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 22px;
            color: #100926;
            line-height: 26px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 2px;
          }

          .title {
            height: 22px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 16px;
            color: #100926;
            line-height: 19px;
            text-align: left;
            font-style: normal;
          }
        }

        .desc {
          width: 283px;
          height: 96px;
          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          color: #8c95b3;
        }

      }

      .item:last-child {
        margin-right: 0;
      }
    }
  }

  .paper {
    width: 100%;
    background: #FFFFFF;
    padding-top: 37px;
    padding-bottom: 57px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      height: 45px;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 32px;
      color: #100926;
      line-height: 38px;
      font-style: normal;
      margin-bottom: 24px;
    }

    .content {
      width: 1280px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      .item {
        width: 411px;
        height: 352px;
        background: #FFFFFF;
        box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
        border-radius: 12px 12px 12px 12px;
        margin-right: 23px;
        margin-bottom: 24px;
        padding: 16px 18px;

        .img {
          width: 375px;
          height: 210px;
          border-radius: 12px 12px 12px 12px;
          margin-bottom: 24px;
          background-color: red;
        }

        .subtitle {
          height: 48px;
          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 18px;
          color: #100926;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 12px;
        }

        .foot {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .foot_item {
            display: flex;
            align-items: center;
            height: 24px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 12px;
            color: #aeb8d3;
            line-height: 24px;
            font-style: normal;

            .icon {
              width: 14px;
              height: 14px;
              background-color: red;
              margin-right: 4px;
            }
          }

          .foot_item:last-child {
            margin-right: 0;
          }


        }
      }

      .item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }


  .service {
    width: 100%;
    min-height: 685px;
    background: #F6F1FD;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 43px 0;

    .title {
      height: 45px;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
      font-weight: normal;
      font-size: 32px;
      color: #100926;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 41px;
    }

    .content {
      display: flex;
      width: 1280px;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .item {
        width: 260px;
        height: 80px;
        border-radius: 8px 8px 8px 8px;
        background: #fff;
        border: 1px solid #845FF6;
        margin-bottom: 24px;

        display: flex;
        justify-content: center;
        align-items: center;

        .logo {
          width: 196px;
          height: 60px;
        }

      }

      .item:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .footer {
    width: 100%;
    height: 430px;
    background-color: #23212A;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .wechat_ask {
      background-color: red;
    }

    .content {
      width: 1280px;
      display: flex;

      .left {
        margin-right: 101px;

        .logo2 {
          width: 156px;
          height: 55px;
          display: block;
          margin-bottom: 7px;
        }

        .net {
          height: 25px;
          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 18px;
          color: #7c7b80;
          line-height: 21px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 37px;
        }

        .tel {
          min-width: 157px;
          height: 28px;
          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 23px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 2px;
        }

        .tel_text {
          min-width: 155px;
          height: 24px;
          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 16px;
          color: #717076;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 36px;
        }

        .ask {
          width: 156px;
          height: 46px;
          background: #622EFF;
          border-radius: 12px 12px 12px 12px;
          text-align: center;
          cursor: pointer;

          font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
          font-weight: normal;
          font-size: 17px;
          color: #FFFFFF;
          line-height: 46px;
          font-style: normal;
          text-transform: none;


        }


      }

      .middle {
        // width: 520px;
        flex: 1;

        .qun_wrap {
          width: 100%;
          margin-bottom: 61px;

          .title {
            height: 31px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 22px;
            color: #FFFFFF;
            line-height: 26px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 12px;
          }

          .qun {
            display: flex;
            flex-wrap: wrap;

            .item {
              margin-right: 31px;
              display: flex;
              align-items: center;
              margin-bottom: 12px;

              .icon {
                width: 20px;
                height: 20px;
                margin-right: 8px;
              }

              .qun_no {
                height: 20px;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }

            .item:last-child {
              margin-right: 0;
            }
          }
        }

        .info {
          display: flex;
          margin-bottom: 18px;

          .info_item {
            height: 22px;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-right: 71px;
          }

          .info_item:last-child {
            margin-right: 0;
          }
        }

        .info2 {
          display: flex;
          flex-wrap: wrap;

          .info2_item {
            height: 20px;
            cursor: pointer;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 14px;
            color: #6d7790;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-right: 79px;
            margin-bottom: 18px;

          }

          .info2_item:nth-child(4n) {
            // margin-right: 0;
          }
        }
      }

      .right {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .qr_item {
          width: 190px;
          height: 258px;
          background: #FFFFFF;
          border-radius: 12px 12px 12px 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 24px;


          .qr_img {
            width: 190px;
            height: 193px;
            border-radius: 12px 12px 12px 12px;
            margin-bottom: 4px;
            background: red;

          }

          .qr_text {
            width: 175px;
            height: 54px;
            line-height: 54px;
            background: #EBE6FB;
            border-radius: 8px 8px 8px 8px;
            text-align: center;

            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 16px;
            color: #622EFF;
            font-style: normal;
            text-transform: none;
          }
        }

        .qr_item:last-child {
          margin-right: 0;
        }
      }

    }

    .record_number {
      width: 100%;
      height: 3px;

      .record_text {
        height: 20px;
        line-height: 20px;
        padding-top: 10px;
        font-size: 12px;
        color: #fff;
        border-top: 1px solid #fff;
      }
    }

  }
}



.mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  right: 0;
  // background: rgba(95, 95, 95, 0.38);
  z-index: 1000;
}

// 测试分类抽屉
// 测试分类抽屉
.drawer {
  width: 100%;
  position: absolute;
  top: 110px;
  background-color: #fff;
  font-size: 16px;
  z-index: 1000;

  .content {
    height: 0;
    transition: all 0.1s linear;
    display: flex;

    .list {
      display: none;
      transition: all 0.1s linear;

      .list_item {
        display: flex;
        background-color: #fff;
        width: 100%;
        height: auto;
        align-items: stretch;

        .left {
          width: 150px;

          padding: 0 10px;

          .parent_node {
            text-align: center;
            min-height: 60px;
            border-bottom: 2px solid @main-color;
            height: 100%;
            display: flex;
            padding-left: 18px;
            align-items: center;

            .iconfont {
              color: @main-color;
              font-size: 22px;
              margin-right: 5px;
            }

            &:hover {
              color: @main-color;
            }
          }
        }

        .right {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          padding-left: 40px;
          min-height: 60px;
          align-items: center;
          background-color: #f0f7ff;
          border-bottom: 4px solid #fff;

          .tag_item {
            margin: 9px 60px 9px 0;
            min-width: 100px;
            float: left;
            text-align: left;
            cursor: pointer;
          }

          .tag_item:hover {
            color: @main-color;
          }
        }
      }

      .list_item:last-child {
        .left {
          .parent_node {
            border-bottom: 0;
          }
        }
      }
    }
  }
}

.show_drawer {
  .content {
    // min-height: 282px;
    height: auto;

    .list,
    .tag_content {
      display: block;
    }
  }
}

.activeItem {
  color: #6742D6 !important;
}
</style>
